import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-edge-relation',
  templateUrl: './edge-relation.component.html',
  styleUrls: ['./edge-relation.component.css']
})
export class EdgeRelationComponent implements OnInit {
    public edgeRelationKeyno;

    public edit?: Edit;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.edgeRelationKeyno = this.stateService.getStateParams()['edgerelation_keyno'];
    }

    private async loadEdit() {
        if (!!this.edgeRelationKeyno) {
            this.edit = (await this.datatask.Post(3210, { edgerelation_keyno: this.edgeRelationKeyno }))[0];
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    edgerelation_keyno: string;
    code: string;
    platetype: string;
    prod_id_edge: string | number;
    prod_id_plate: string;
    prod_name_edge: string | number;
    prod_name_plate: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('edgeRelation', {
//        templateUrl: 'views/components/views/edgeRelation/edgeRelation.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', '$uibModal', 'stateService', 'modalService', 'translateService', 'edgeRelationService', function ($stateParams, $uibModal, stateService, modalService, translateService, edgeRelationService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let edgeRelationKeyno = $stateParams.edgerelation_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edgeRelationKeyno: edgeRelationKeyno,
//                edit: {},
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await edgeRelationService.getEdgeRelation({ edgerelation_keyno: edgeRelationKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TYPEAHEAD SEARCH FUNCTION CALLS

//            vm.edgeSearch = function (value, searchparam) {
//                return edgeRelationService.edgeSearchKeyname(value, searchparam);
//            };

//            vm.plateSearch = function (value, searchparam) {
//                return edgeRelationService.plateSearchKeyname(value, searchparam);
//            };

//            vm.edgeSelectItem = function (item, model) {
//                if (item?.edge_keyno && item.edge_keyno !== '') {
//                    //console.dir(item);
//                    vm.model.edit.prod_id_edge = item.edge_keyno;
//                    vm.model.edit.prod_name_edge = item.edge_name;
//                    vm.model.edit.edge_keyname = item.edge_keyname;
//                }
//            };

//            vm.plateSelectItem = function (item, model) {
//                if (item?.plate_keyno && item.plate_keyno !== '') {
//                    //console.dir(item);
//                    vm.model.edit.prod_id_plate = item.plate_keyno;
//                    vm.model.edit.prod_name_plate = item.plate_name;
//                    vm.model.edit.plate_keyname = item.plate_keyname;
//                }
//            };

//            // #endregion TYPEAHEAD SEARCH FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                edgeRelationService.save(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.delete = function () {
//                vm.model.lockedDelete = true;

//                var modalInstance = $uibModal.open({
//                    animation: true,
//                    backdrop: 'static',
//                    component: 'ttConfirm',
//                    resolve: {
//                        message: function () {
//                            return '';
//                        }
//                    }
//                });

//                modalInstance.result.then(function (confirmed) {
//                    if (confirmed !== true) {
//                        vm.model.lockedDelete = false;
//                        return;
//                    }

//                    edgeRelationService.delete(vm.model.edit).then(function (response) {
//                        if (response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: function (dialogItself) {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back();
//                        }
//                    });
//                });
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region LIFE CYCLE FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion LIFE CYCLE FUNCTION

//        }]
//    });
//})();
